module.exports = __webpack_public_path__ + "static/media/dln_shells.d4a17ee7.png";